import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

// Login Redux States
import { GET_ENTRY_STRATEGY_BY_ID } from './actionTypes';
import { getEntryStrategyByIdSuccessful, getEntryStrategyByIdFailed } from './actions';

// Include call API
import { getEntryStrategiesAPI } from '../../../api/entryestrategies';

const entryStrategiesAPI = getEntryStrategiesAPI();

function* getEntryStrategyById(action) {
  const { token, id } = action.payload;
  try {
    const response = yield call(entryStrategiesAPI.getEntryStrategyById, token, id);
    yield put(getEntryStrategyByIdSuccessful(response));
  } catch (error) {
    yield put(getEntryStrategyByIdFailed(error));
  }
}

export function* watchGetEntryStrategyById() {
  yield takeEvery(GET_ENTRY_STRATEGY_BY_ID, getEntryStrategyById);
}

function* getEntryStrategyByIdSaga() {
  yield all([fork(watchGetEntryStrategyById)]);
}

export default getEntryStrategyByIdSaga;
